import axios from "axios";
import { apiUrl } from "../../common/api/config";
import useFetch from "../../global/hooks/useFetch";

export const loginAsUser = async (userId) => {
  const token = localStorage.getItem("accessToken");
  const response = await axios.post(
    `${apiUrl}/admin-panel/users/${userId}/login-as/`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const useAdminDashboardStats = () => {
  const { data, loading, error, refetch } = useFetch(
    "/admin-panel/dashboard/stats/",
  );

  return {
    stats: data,
    loading,
    error,
    refetch,
  };
};

export const useUsersStats = () => {
  const { data, loading, error, refetch } = useFetch(
    "/admin-panel/users/stats/",
  );

  return {
    usersStats: data,
    loading,
    error,
    refetch,
  };
};

export const useProjectsStats = () => {
  const { data, loading, error, refetch } = useFetch(
    "/admin-panel/projects/stats/",
  );

  return {
    projectsStats: data,
    loading,
    error,
    refetch,
  };
};

// Sources Stats Hook
export const useSourcesStats = () => {
  const { data, loading, error, refetch } = useFetch(
    "/admin-panel/sources/stats/",
  );

  return {
    sourcesStats: data,
    loading,
    error,
    refetch,
  };
};

export const useUsersList = (page = 1, pageSize = 20, searchTerm = "") => {
  const searchParam = searchTerm
    ? `&search=${encodeURIComponent(searchTerm)}`
    : "";
  const { data, loading, error, refetch } = useFetch(
    `/admin-panel/users/?page=${page}&page_size=${pageSize}${searchParam}`,
  );

  return {
    users: data?.results || [],
    totalCount: data?.count || 0,
    totalPages: data?.count ? Math.ceil(data.count / pageSize) : 0,
    currentPage: page,
    hasNext: !!data?.next,
    hasPrevious: !!data?.previous,
    loading,
    error,
    refetch,
  };
};

export const useSourcesList = (page = 1, pageSize = 20, searchTerm = "") => {
  const searchParam = searchTerm
    ? `&search=${encodeURIComponent(searchTerm)}`
    : "";
  const { data, loading, error, refetch } = useFetch(
    `/admin-panel/sources/?page=${page}&page_size=${pageSize}${searchParam}`,
  );

  return {
    sources: data?.results || [],
    totalCount: data?.count || 0,
    totalPages: data?.count ? Math.ceil(data.count / pageSize) : 0,
    currentPage: page,
    hasNext: !!data?.next,
    hasPrevious: !!data?.previous,
    loading,
    error,
    refetch,
  };
};

export const useProjectsList = (page = 1, pageSize = 20, searchTerm = "") => {
  const searchParam = searchTerm
    ? `&search=${encodeURIComponent(searchTerm)}`
    : "";
  const { data, loading, error, refetch } = useFetch(
    `/admin-panel/projects/?page=${page}&page_size=${pageSize}${searchParam}`,
  );

  return {
    projects: data?.results || [],
    totalCount: data?.count || 0,
    totalPages: data?.count ? Math.ceil(data.count / pageSize) : 0,
    currentPage: page,
    loading,
    error,
    refetch,
  };
};

export const useSubscriptionStats = () => {
  const { data, loading, error, refetch } = useFetch(
    "/admin-panel/subscriptions/stats/",
  );

  return {
    subscriptionStats: data,
    loading: loading,
    error,
    refetch,
  };
};

export const useAuditLogs = (page = 1, pageSize = 20) => {
  const { data, loading, error, refetch } = useFetch(
    `/admin-panel/audit-logs/?page=${page}&page_size=${pageSize}`,
  );

  return {
    logs: data?.results || [],
    totalCount: data?.count || 0,
    totalPages: data?.count ? Math.ceil(data.count / pageSize) : 0,
    currentPage: page,
    loading,
    error,
    refetch,
  };
};
